export default "<app-cabecera></app-cabecera>\r\n<app-menu></app-menu>\r\n<app-contenido></app-contenido>\r\n<app-pie></app-pie>";